import moment from 'moment';
import { cutoffHours } from './appConstants';

export const addFunctionsToCols = (columns, fun, field) => {
  const findIndex = columns?.findIndex(c => c?.field == field);
  columns[findIndex].eventFunction = fun;
};

export const textTruncate = (str, length = 100) => {
  return str?.slice(0, length) + '...';
};

export const calculateExpectedDeliveryDate = days => {
  if (days) {
    const currentHour = new Date().getHours();

    let addingDays = days;

    // if (currentHour >= cutoffHours) {
    // addingDays = addingDays + 1;
    // }
    if (currentHour <= cutoffHours) {
      addingDays = addingDays - 1;
    }

    return moment().add(addingDays, 'days').format('DD/MM/YYYY');
  }
};

export const priceFormatter = amount => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(amount);
};
